import React from 'react'
import PropTypes from 'prop-types'
import { polyglot } from '../../../index'
import { Panel } from '../../common/Panel/Panel'
import { SingleLineTable } from '../../common/SingleLineTable/SingleLineTable'
import moment from 'moment/moment'

const dateFormat = {
  standartData: 'YYYY-MM-DD'
}

const Allergies = ({allergies, handleAllergySubmit, handleAllergyChange, config, doctorName, patientBirthDate}) => {
  let status = 'panel-default'
  if (allergies && Object.keys(allergies).length > 0) {
    status = 'panel-danger'
  }
  return <Panel heading={polyglot.t('staticFields.home.allergies.allergies')} panelType={status}>
    <SingleLineTable
      minDateForCalendar={patientBirthDate}
      maxDateForCalendar={moment().format(dateFormat.standartData)}
      doctorName={doctorName}
      config={config}
      handleChange={handleAllergyChange}
      insertionButtonText={polyglot.t('staticFields.home.allergies.addAllergy')}
      nameOfModal={polyglot.t('staticFields.home.allergies.allergyRegister')}
      insertionFieldDescription={polyglot.t('staticFields.home.allergies.allergyDescription')}
      data={allergies}
      handleSubmit={handleAllergySubmit} />
  </Panel>
}

Allergies.propTypes = {
  allergies: PropTypes.object,
  handleAllergySubmit: PropTypes.func.isRequired,
  handleAllergyChange: PropTypes.func.isRequired,
  config: PropTypes.object.isRequired,
  doctorName: PropTypes.string
}

export default Allergies



// WEBPACK FOOTER //
// ./src/components/general/Home/Allergies.js